var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('a',{staticClass:"link",attrs:{"href":_vm.resultItem.url}},[_c('h3',[_vm._v(_vm._s(_vm.resultItem.title))]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.resultItem.text))]),_vm._v("\n        Lees meer")])])}
var staticRenderFns = []

export { render, staticRenderFns }